import { UserFacingError } from './errors'

export class ProfilePhotoUploadError extends UserFacingError {
  constructor(message?: string) {
    super(message ?? 'Upload failed. Please try again.')
    this.name = 'ProfilePhotoUploadError'
  }
}
